import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10.8 7h6.4a4.8 4.8 0 014.8 4.8v6.4a4.8 4.8 0 01-4.8 4.8h-6.4A4.8 4.8 0 016 18.2v-6.4A4.8 4.8 0 0110.8 7zm0 1.6a3.2 3.2 0 00-3.2 3.2v6.4a3.2 3.2 0 003.2 3.2h6.4a3.2 3.2 0 003.2-3.2v-6.4a3.2 3.2 0 00-3.2-3.2h-6.4zm4.8 5.6H18a.8.8 0 110 1.6h-2.4a.8.8 0 110-1.6zM14 17.4h4a.8.8 0 110 1.6h-4a.8.8 0 110-1.6zm0-6.4h4a.8.8 0 110 1.6h-4a.8.8 0 110-1.6zm-3.338 4.194l1.698-1.698a.8.8 0 111.131 1.132L11.23 16.89a.799.799 0 01-1.132 0l-1.131-1.13a.8.8 0 011.13-1.131l.566.565z"
});
function SvgQuickCalculation(props) {
  return /*#__PURE__*/React.createElement("svg", props, _ref);
}
export default SvgQuickCalculation;